module.exports = "<div *ngIf=\"global.loading || window.loading\" class=\"admin-loader\">\r\n <p class=\"text text-bold\">{{global.loadingText}}</p>\r\n <div class=\"loader\">\r\n  <svg class=\"circular\" viewBox=\"25 25 50 50\">\r\n   <circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\" />\r\n  </svg>\r\n </div>\r\n</div>\r\n<div [class.blured]=\"global.loading || window.loading\">\r\n <router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main